import qs from 'query-string';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { getOtherActions } from './selectors';
import {
  displayDataCorrectionForm,
  displayStepForm,
  setOpenStepFormTabEntityDisplay,
} from '../../actions/EntityDisplayActions';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import { getNetworkStatus } from '../../form-designer/selectors/common.selectors';
import MenuButton from '../MenuButton';

function OtherActions() {
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const { search } = useLocation();

  const otherActions = useFormSelector(getOtherActions);
  const { isMobileDevice } = useWindowDimensions();
  const isOnline = useSelector(getNetworkStatus);

  const { entityType } = qs.parse(search) || {};

  const otherActionsOptions = otherActions.map((action) => ({
    text: action.translatedText,
    onClick: () => {
      const actionData = action.referencedActionData ?? {};
      isMobileDevice && dispatch(setOpenStepFormTabEntityDisplay(true));

      const isDataCorrectionAction = actionData.StepID === 'SystemDataCorrection';
      const actionPayloadData = {
        containerWorkflowKey: actionData.ContainerWorkflowKey,
        workflowKey: actionData.WorkflowKey,
        stepId: actionData.StepID,
        itmId: actionData.ItmID,
        workflowId: actionData.WorkflowID,
        parentWorkflowId: actionData.ParentWorkflowId,
        actionName: actionData.ActionName,
      };

      isDataCorrectionAction
        ? dispatch(displayDataCorrectionForm({ ...actionPayloadData, entityType }))
        : dispatch(displayStepForm(actionPayloadData));
    },
  }));

  return (
    <MenuButton
      buttonText={translateString('Action')}
      menuItems={otherActionsOptions}
      disabled={otherActionsOptions.length === 0 || !isOnline}
    />
  );
}

export default OtherActions;
